export * from '@shikijs/engine-oniguruma/wasm-inlined';
export { default } from '@shikijs/engine-oniguruma/wasm-inlined';
